// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import React from 'react';

export interface CloseIconProps {
  /** Square size in px (width and height). Defaults to 24. */
  size?: number;
  /** Stroke colour applied to the X. Defaults to brand purple. */
  color?: string;
  className?: string;
  style?: React.CSSProperties;
  'aria-label'?: string;
  'aria-hidden'?: boolean;
}

/**
 * Outlined "close" / X icon — two diagonal strokes forming a cross.
 *
 * Used as the "open" state of {@link HamburgerMenu}; default stroke is brand
 * purple to match the surrounding chip background.
 */
export const CloseIcon: React.FC<CloseIconProps> = ({
  size = 24,
  color = '#2D0A6C',
  className,
  style,
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    role={ariaLabel ? 'img' : undefined}
    aria-label={ariaLabel}
    aria-hidden={ariaHidden ?? !ariaLabel}
    data-testid="close-icon"
  >
    <line
      x1="0.75"
      y1="16.6893"
      x2="16.6893"
      y2="0.749999"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <line
      x1="0.81066"
      y1="0.75"
      x2="16.75"
      y2="16.6893"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
